module.exports = __webpack_public_path__ + "docker-compose.webp";